import React from 'react';
import { Layout } from '../components/Layout';
import { SEO } from '../components/SEO';
import { Mail, Shield } from 'lucide-react';
export function PrivacyPolicyPage() {
  return <Layout data-id="element-1775">
      <SEO title="Politique de Confidentialité" description="Politique de confidentialité de l'ADCC Bénin. Découvrez comment nous collectons, utilisons et protégeons vos données personnelles." keywords="politique de confidentialité, ADCC Bénin, protection données personnelles, RGPD" url="https://adcc.africa/privacy-policy" data-id="element-1776" />

      {/* Header */}
      <div className="bg-[#2C3E50] text-white py-16" data-id="element-1777">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-1778">
          <div className="flex justify-center mb-4" data-id="element-1779">
            <Shield className="w-12 h-12 text-[#1E88E5]" data-id="element-1780" />
          </div>
          <h1 className="text-4xl font-bold mb-4" data-id="element-1781">
            Politique de Confidentialité
          </h1>
          <p className="text-gray-300" data-id="element-1782">ADCC Africa</p>
        </div>
      </div>

      {/* Content */}
      <section className="py-16 bg-white" data-id="element-1783">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1784">
          <p className="text-sm text-gray-500 mb-10" data-id="element-1785">
            Dernière mise à jour : 2026
          </p>

          <p className="text-gray-700 leading-relaxed mb-10" data-id="element-1786">
            ADCC Africa (« nous », « notre », « nos ») collecte et traite les
            données personnelles soumises via les formulaires de ce site web.
          </p>

          {/* Data we collect */}
          <div className="mb-10" data-id="element-1787">
            <h2 className="text-xl font-bold text-[#2C3E50] mb-4" data-id="element-1788">
              Données collectées
            </h2>
            <ul className="space-y-2 text-gray-700" data-id="element-1789">
              <li className="flex items-start gap-2" data-id="element-1790">
                <span className="text-[#1E88E5] mt-1.5 text-xs" data-id="element-1791">●</span>
                <span data-id="element-1792">Nom</span>
              </li>
              <li className="flex items-start gap-2" data-id="element-1793">
                <span className="text-[#1E88E5] mt-1.5 text-xs" data-id="element-1794">●</span>
                <span data-id="element-1795">Adresse email</span>
              </li>
              <li className="flex items-start gap-2" data-id="element-1796">
                <span className="text-[#1E88E5] mt-1.5 text-xs" data-id="element-1797">●</span>
                <span data-id="element-1798">Numéro de téléphone</span>
              </li>
              <li className="flex items-start gap-2" data-id="element-1799">
                <span className="text-[#1E88E5] mt-1.5 text-xs" data-id="element-1800">●</span>
                <span data-id="element-1801">Contenu des messages</span>
              </li>
              <li className="flex items-start gap-2" data-id="element-1802">
                <span className="text-[#1E88E5] mt-1.5 text-xs" data-id="element-1803">●</span>
                <span data-id="element-1804">Données techniques (adresse IP, navigateur)</span>
              </li>
            </ul>
          </div>

          {/* Purpose */}
          <div className="mb-10" data-id="element-1805">
            <h2 className="text-xl font-bold text-[#2C3E50] mb-4" data-id="element-1806">Finalité</h2>
            <p className="text-gray-700 mb-3" data-id="element-1807">
              Nous utilisons ces données pour :
            </p>
            <ul className="space-y-2 text-gray-700" data-id="element-1808">
              <li className="flex items-start gap-2" data-id="element-1809">
                <span className="text-[#1E88E5] mt-1.5 text-xs" data-id="element-1810">●</span>
                <span data-id="element-1811">Répondre aux demandes</span>
              </li>
              <li className="flex items-start gap-2" data-id="element-1812">
                <span className="text-[#1E88E5] mt-1.5 text-xs" data-id="element-1813">●</span>
                <span data-id="element-1814">Fournir les services demandés</span>
              </li>
              <li className="flex items-start gap-2" data-id="element-1815">
                <span className="text-[#1E88E5] mt-1.5 text-xs" data-id="element-1816">●</span>
                <span data-id="element-1817">Gérer les relations professionnelles</span>
              </li>
              <li className="flex items-start gap-2" data-id="element-1818">
                <span className="text-[#1E88E5] mt-1.5 text-xs" data-id="element-1819">●</span>
                <span data-id="element-1820">Améliorer notre site web</span>
              </li>
            </ul>
          </div>

          {/* Legal basis */}
          <div className="mb-10" data-id="element-1821">
            <h2 className="text-xl font-bold text-[#2C3E50] mb-4" data-id="element-1822">
              Base légale
            </h2>
            <p className="text-gray-700 leading-relaxed" data-id="element-1823">
              Les données sont traitées sur la base du consentement de
              l'utilisateur et de l'intérêt légitime de l'organisation.
            </p>
          </div>

          {/* Data sharing */}
          <div className="mb-10" data-id="element-1824">
            <h2 className="text-xl font-bold text-[#2C3E50] mb-4" data-id="element-1825">
              Partage des données
            </h2>
            <p className="text-gray-700 leading-relaxed" data-id="element-1826">
              Nous ne vendons pas de données personnelles. Les données peuvent
              être traitées par des prestataires de confiance (hébergement,
              email, analytics, outils de formulaires) uniquement à des fins
              opérationnelles.
            </p>
          </div>

          {/* Data storage */}
          <div className="mb-10" data-id="element-1827">
            <h2 className="text-xl font-bold text-[#2C3E50] mb-4" data-id="element-1828">
              Stockage des données
            </h2>
            <p className="text-gray-700 leading-relaxed" data-id="element-1829">
              Les données sont stockées de manière sécurisée et conservées
              uniquement le temps nécessaire aux obligations professionnelles ou
              légales.
            </p>
          </div>

          {/* User rights */}
          <div className="mb-10" data-id="element-1830">
            <h2 className="text-xl font-bold text-[#2C3E50] mb-4" data-id="element-1831">
              Droits des utilisateurs
            </h2>
            <p className="text-gray-700 mb-3" data-id="element-1832">Vous pouvez demander :</p>
            <ul className="space-y-2 text-gray-700" data-id="element-1833">
              <li className="flex items-start gap-2" data-id="element-1834">
                <span className="text-[#1E88E5] mt-1.5 text-xs" data-id="element-1835">●</span>
                <span data-id="element-1836">L'accès à vos données</span>
              </li>
              <li className="flex items-start gap-2" data-id="element-1837">
                <span className="text-[#1E88E5] mt-1.5 text-xs" data-id="element-1838">●</span>
                <span data-id="element-1839">La correction de vos données</span>
              </li>
              <li className="flex items-start gap-2" data-id="element-1840">
                <span className="text-[#1E88E5] mt-1.5 text-xs" data-id="element-1841">●</span>
                <span data-id="element-1842">La suppression de vos données</span>
              </li>
              <li className="flex items-start gap-2" data-id="element-1843">
                <span className="text-[#1E88E5] mt-1.5 text-xs" data-id="element-1844">●</span>
                <span data-id="element-1845">Le retrait de votre consentement</span>
              </li>
            </ul>
            <div className="mt-4 flex items-center gap-2 text-gray-700" data-id="element-1846">
              <Mail className="w-4 h-4 text-[#1E88E5]" data-id="element-1847" />
              <span data-id="element-1848">
                Contact :{' '}
                <a href="mailto:contact@adcc.africa" className="text-[#1E88E5] hover:underline" data-id="element-1849">
                  contact@adcc.africa
                </a>
              </span>
            </div>
          </div>

          {/* Cookies */}
          <div className="mb-10" data-id="element-1850">
            <h2 className="text-xl font-bold text-[#2C3E50] mb-4" data-id="element-1851">Cookies</h2>
            <p className="text-gray-700 leading-relaxed" data-id="element-1852">
              Ce site web peut utiliser des cookies à des fins d'analyse et de
              fonctionnalité.
            </p>
          </div>

          {/* Contact */}
          <div className="bg-gray-50 rounded-xl p-6 border border-gray-100" data-id="element-1853">
            <h2 className="text-xl font-bold text-[#2C3E50] mb-4" data-id="element-1854">Contact</h2>
            <p className="text-gray-700" data-id="element-1855">ADCC Africa</p>
            <p className="text-gray-700 flex items-center gap-2 mt-2" data-id="element-1856">
              <Mail className="w-4 h-4 text-[#1E88E5]" data-id="element-1857" />
              <a href="mailto:contact@adcc.africa" className="text-[#1E88E5] hover:underline" data-id="element-1858">
                contact@adcc.africa
              </a>
            </p>
            <p className="text-gray-700 mt-2" data-id="element-1859">
              Site web :{' '}
              <a href="https://www.adcc.africa" className="text-[#1E88E5] hover:underline" data-id="element-1860">
                https://www.adcc.africa
              </a>
            </p>
          </div>
        </div>
      </section>
    </Layout>;
}